import {
	initiativeByID,
	initiativeCreate,
	initiativeDestroy,
	initiativeList,
	initiativeUpdate,
} from '@/services/agency/testimonialInitiatives.service'

export default {
	namespaced: true,
	state: {
		initiativeList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		initiative: {},
		initiativeStatus: 'pending',
		initiativeSaveStatus: 'init',
		initiativeDeleteStatus: 'init',
	},
	getters: {
		getInitiativeList(state) {
			return state.initiativeList
		},
		getInitiative(state) {
			return state.initiative
		},
		getInitiativeDeleteStatus(state) {
			return state.initiativeDeleteStatus
		},
		getInitiativeSaveStatus(state) {
			return state.initiativeSaveStatus
		},
		getInitiativeStatus(state) {
			return state.initiativeStatus
		},
	},
	mutations: {
		INITIATIVE_LIST(state, value) {
			state.initiativeList = value
		},
		SET_INITIATIVE(state, value) {
			state.initiative = value
		},
		INITIATIVE_STATUS(state, value) {
			state.initiativeStatus = value
		},
		INITIATIVE_SAVE_STATUS(state, value) {
			state.initiativeSaveStatus = value
		},
		INITIATIVE_DELETE_STATUS(state, value) {
			state.initiativeDeleteStatus = value
		},
	},
	actions: {
		async fetchInitiativeList({ commit }, params) {
			commit('INITIATIVE_STATUS', 'pending')
			commit('INITIATIVE_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await initiativeList(params)
				commit('INITIATIVE_STATUS', 'init')
				commit('INITIATIVE_LIST', data)
				return data
			} catch (error) {
				commit('INITIATIVE_STATUS', 'init')
				throw error
			}
		},
		async fetchInitiativeByID({ commit }, params) {
			commit('INITIATIVE_STATUS', 'pending')
			try {
				const { data } = await initiativeByID(params)
				commit('INITIATIVE_STATUS', 'init')
				commit('SET_INITIATIVE', data.data)
				return data
			} catch (error) {
				commit('INITIATIVE_STATUS', 'init')
				return error
			}
		},
		async saveNewInitiative({ commit }, params) {
			commit('INITIATIVE_SAVE_STATUS', 'pending')
			try {
				const { data } = await initiativeCreate(params)
				commit('INITIATIVE_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('INITIATIVE_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateInitiative({ commit }, params) {
			commit('INITIATIVE_SAVE_STATUS', 'pending')
			try {
				const { data } = await initiativeUpdate(params)
				commit('INITIATIVE_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('INITIATIVE_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteInitiativeByID({ commit }, params) {
			commit('INITIATIVE_DELETE_STATUS', 'pending')
			try {
				const { data } = await initiativeDestroy(params)
				commit('INITIATIVE_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('INITIATIVE_DELETE_STATUS', 'error')
				return error
			}
		},
	},
}
